import FeaturedListItem from './FeaturedListItem';
import FeaturedListItemContainer from './FeaturedListItem.container';

export default FeaturedListItemContainer(FeaturedListItem);
